import React, {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {connect, useDispatch} from "react-redux";
import * as yup from "yup";

import {
  loadingToggleAction,
  loginWithSc,
  signupAction,
} from "../../store/actions/AuthActions";

// image

import logo from "../../images/Logo-login.png";
import SideBg from "../components/shared/loginSideBg";
import {set, useForm} from "react-hook-form";
import {Formik} from "formik";
import TelVerification from "../components/shared/telVerification";
import {normalizePhoneForOtp} from "../../utils/otp";
import {CountrySelector} from "react-international-phone";
import FacebookIcon from "../../images/icons/facebookIcon";
import AppleIcon from "../../images/icons/appleIcon";
import {
  FacebookAuthProvider,
  GoogleAuthProvider,
  OAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import {auth} from "../../utils/firebase";
import {signedBy} from "../../utils/constants";
import GoogleIcon from "../../images/icons/GoogleIcon";
import FooterLogin from "../layouts/FooterLogin";
import {showToastModal} from "../components/shared/ToastModalSwal";
import {useTranslation} from "react-i18next";
import {getSocialAuthToast} from "../../utils/socialAuthMessages";
import TurnstileWidget from "../components/shared/TurnstileWidget";

const CustomGoogleButton = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const {t} = useTranslation();

  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      await dispatch(loginWithSc(user.email, user, signedBy.GOOGLE, navigate));
      showToastModal(getSocialAuthToast(t, signedBy.GOOGLE, undefined, "success"));
    } catch (error) {
      showToastModal(getSocialAuthToast(t, signedBy.GOOGLE, error));
    }
  };

  return (
    <button
      type="button"
      onClick={handleGoogleLogin}
      className="flex w-1/3 max-[769px]:w-full gap-2 items-center justify-center bg-white border border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-[10px] "
    >
      <GoogleIcon />
      <div className="flex flex-col justify-start text-[#19295C]">
        <span className="font-normal text-[7px] text-start">
          S'inscrire avec
        </span>
        <span className="font-semibold text-[14px] text-start">Google</span>
      </div>
    </button>
  );
};

function Register(props) {
  const schema = yup.object().shape({
    firstName: yup.string().required("Champ obligatoire"),
    birthDate: yup.date().required("Champ obligatoire"),
    lastName: yup.string().required("Champ obligatoire"),
    gender: yup.string().required("Champ obligatoire"),
    email: yup
      .string()
      .required("Champ obligatoire")
      .email("L'e-mail doit être un e-mail valide"),

    password: yup
      .string()
      .required("Champ obligatoire")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{8,128}$/,
        "Doit contenir entre 8 et 128 caractères, avec une majuscule, une minuscule et un chiffre",
      )
      .min(8, "Doit contenir au moins 8 caractères")
      .max(128, "Doit contenir au maximum 128 caractères"),
    confirmPassword: yup
      .string()
      .oneOf(
        [yup.ref("password"), null],
        "Les mots de passe doivent correspondre",
      )
      .required("Champ obligatoire"),
  });

  const [step, setStep] = useState(false);
  const [phone, setPhone] = useState("");
  const [country, setCountry] = useState("fr");
  const [dialCode, setDialCode] = useState("+33");
  const [phoneError, setPhoneError] = useState(false);
  const [roleError, setRoleError] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState(null);
  const [turnstileRequired, setTurnstileRequired] = useState(true);
  const [turnstileResetKey, setTurnstileResetKey] = useState(0);
  const [turnstileError, setTurnstileError] = useState("");

  const [selectedRole, setSelectedRole] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {t} = useTranslation();
  const handleFacebookLogin = async () => {
    const provider = new FacebookAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      await dispatch(loginWithSc(user.email, user, signedBy.FACEBOOK, navigate));
      showToastModal(
        getSocialAuthToast(t, signedBy.FACEBOOK, undefined, "success"),
      );
    } catch (error) {
      showToastModal(getSocialAuthToast(t, signedBy.FACEBOOK, error));
    }
  };

  const handleAppleLogin = async () => {
    const provider = new OAuthProvider("apple.com");
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      await dispatch(loginWithSc(user.email, user, signedBy.APPLE, navigate));
      showToastModal(getSocialAuthToast(t, signedBy.APPLE, undefined, "success"));
    } catch (error) {
      showToastModal(getSocialAuthToast(t, signedBy.APPLE, error));
    }
  };

  return (
    <>
      <div className="row justify-content-center h-100 align-items-center">
        <div className="col-md-10 col-lg-10 col-xl-8">
          <div className="authincation-content">
            <div className="row no-gutters">
              <div className="col-xl-12">
                <div className="auth-form font-[Poppins]">
                  {/* <div className="text-center mb-3">
												<Link to="/"><img src={logo} alt="" /></Link>
											</div> */}

                  <Formik
                    initialValues={{
                      firstName: "",
                      lastName: "",
                      email: "",
                      password: "",
                      confirmPassword: "",
                      gender: "",
                      birthDate: "",
                    }}
                    validationSchema={schema}
                    validateOnChange={false}
                    validateOnBlur={true}
                    onSubmit={(values, {setSubmitting}) => {
                      dispatch(loadingToggleAction(true));
                      const {confirmPassword, ...rest} = values;
                      dispatch(
                        signupAction(
                          {
                            ...rest,
                            phone: normalizePhoneForOtp(dialCode, phone),
                            fcmToken: "",
                            roleId: selectedRole,
                          },
                          navigate,
                          setStep,
                        ),
                      );
                      setSubmitting(false);
                    }}
                  >
                    {({
                      values,
                      errors,
                      setFieldError,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      validateForm,
                      setFieldTouched,
                      touched,
                    }) => (
                      <form onSubmit={handleSubmit}>
                        {!step ? (
                          <>
                            <div className="">
                              <h2 className=" text-left text-primary font-bold text-[28px] uppercase leading-9 ">
                                S'inscrire
                              </h2>
                            </div>
                            <h4 className="text-left leading-9 text-[#3D4465] text-sm font-medium">
                              Entrez vos coordonnées ci-dessous
                            </h4>
                            {props.errorMessage && (
                              <div className="bg-red-300 text-red-900 border border-red-900 p-1 my-2">
                                {props.errorMessage}
                              </div>
                            )}
                            {props.successMessage && (
                              <div className="bg-green-300 text-green-900 border border-green-900 p-1 my-2">
                                {props.successMessage}
                              </div>
                            )}
                            <div className="flex gap-2 w-full max-[769px]:flex-col max-[769px]:gap-0 ">
                              <div className="form-group w-1/2  max-[769px]:w-full ">
                                <label className="font-medium text-sm leading-9 text-[#7E7E7E] ">
                                  Nom
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="nom"
                                  name="lastName"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.lastName}
                                />
                                {touched.lastName && errors.lastName && (
                                  <div
                                    className="invalid-feedback animated fadeInUp"
                                    style={{display: "block"}}
                                  >
                                    {errors.lastName}
                                  </div>
                                )}
                              </div>

                              <div className="form-group w-1/2    max-[769px]:w-full">
                                <label className="font-medium text-sm leading-9 text-[#7E7E7E] ">
                                  Prénom
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="prénom"
                                  name="firstName"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.firstName}
                                />
                                {touched.firstName && errors.firstName && (
                                  <div
                                    className="invalid-feedback animated fadeInUp"
                                    style={{display: "block"}}
                                  >
                                    {errors.firstName}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="flex gap-2 w-full max-[769px]:flex-col max-[769px]:gap-0">
                              <div className="form-group w-1/2  max-[769px]:w-full">
                                <label className="font-medium text-sm leading-9 text-[#7E7E7E] ">
                                  {" "}
                                  Email
                                </label>
                                <input
                                  type="email"
                                  className="form-control"
                                  name="email"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.email}
                                />
                                {touched.email && errors.email && (
                                  <div
                                    className="invalid-feedback animated fadeInUp"
                                    style={{display: "block"}}
                                  >
                                    {errors.email}
                                  </div>
                                )}
                              </div>
                              <div className="form-group w-1/2  max-[769px]:w-full">
                                <label className="font-medium text-sm leading-9 text-[#7E7E7E] ">
                                  {" "}
                                  Numéro de téléphone
                                </label>

                                <div className="flex gap-2 justify-start items-center">
                                  <CountrySelector
                                    className="flex justify-start items-center"
                                    dropdownArrowClassName="absolute  right-0"
                                    flagClassName="absolute left-2"
                                    selectedCountry={country}
                                    onSelect={(el) => {
                                      setCountry(el.iso2);
                                      setDialCode("+" + el.dialCode);
                                    }}
                                    renderButtonWrapper={({
                                      children,
                                      rootProps,
                                    }) => (
                                      <button
                                        type="button"
                                        {...rootProps}
                                        className=" w-[100px] h-[51px] max-[1400px]:h-[41px] bg-white border rounded-lg relative"
                                      >
                                        {children}
                                        <div className="absolute top-[13px] max-[1400px]:top-[8px]  right-5">
                                          {dialCode}
                                        </div>
                                      </button>
                                    )}
                                  />
                                  <input
                                    type="tel"
                                    className="form-control"
                                    value={phone}
                                    onChange={(e) => {
                                      setPhone(e.target.value);
                                      setPhoneError(false);
                                    }}
                                  />
                                </div>
                                {phoneError && (
                                  <div className="text-danger fs-12">
                                    Champ obligatoire
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="flex gap-2 w-full max-[769px]:flex-col max-[769px]:gap-0 ">
                              <div className="form-group w-1/2  max-[769px]:w-full">
                                <label className="font-medium text-sm leading-9 text-[#7E7E7E] ">
                                  Genre
                                </label>
                                <select
                                  className="form-control custom-select-arrow"
                                  name="gender"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.gender}
                                >
                                  <option value={""} selected disabled hidden>
                                    Choisir Votre genre
                                  </option>
                                  <option value={"female"}>Femme</option>
                                  <option value={"male"}>Homme</option>
                                  <option value={"other"}>Autre</option>
                                </select>
                                {touched.gender && errors.gender && (
                                  <div
                                    className="invalid-feedback animated fadeInUp"
                                    style={{display: "block"}}
                                  >
                                    {errors.gender}
                                  </div>
                                )}
                              </div>
                              <div className="form-group w-1/2  max-[769px]:w-full">
                                <label className="font-medium text-sm leading-9 text-[#7E7E7E] ">
                                  Date de naissance
                                </label>
                                <input
                                  type="date"
                                  className="form-control"
                                  name="birthDate"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.birthDate}
                                />
                                {touched.birthDate && errors.birthDate && (
                                  <div
                                    className="invalid-feedback animated fadeInUp"
                                    style={{display: "block"}}
                                  >
                                    {errors.birthDate}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="flex gap-2 w-full max-[769px]:flex-col max-[769px]:gap-0">
                              <div className="form-group w-1/2  max-[769px]:w-full">
                                <label className="font-medium text-sm leading-9 text-[#7E7E7E] ">
                                  Mot de passe
                                </label>
                                <input
                                  type="password"
                                  className="form-control"
                                  name="password"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.password}
                                />
                                {touched.password && errors.password && (
                                  <div
                                    className="invalid-feedback animated fadeInUp"
                                    style={{display: "block"}}
                                  >
                                    {errors.password}
                                  </div>
                                )}
                              </div>
                              <div className="form-group w-1/2  max-[769px]:w-full">
                                <label className="font-medium text-sm leading-9 text-[#7E7E7E] ">
                                  Confirmer le mot de passe
                                </label>
                                <input
                                  type="password"
                                  className="form-control"
                                  name="confirmPassword"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.confirmPassword}
                                />
                                {touched.confirmPassword &&
                                  errors.confirmPassword && (
                                    <div
                                      className="invalid-feedback animated fadeInUp"
                                      style={{display: "block"}}
                                    >
                                      {errors.confirmPassword}
                                    </div>
                                  )}
                              </div>
                            </div>

                            <div className="form-group w-1/2  max-[769px]:w-full">
                              <label className="font-medium text-sm leading-9 text-[#7E7E7E] ">
                                Vous êtes ?{" "}
                              </label>
                              <div className="flex w-full">
                                <label className="cursor-pointer w-1/2">
                                  <input
                                    type="radio"
                                    name="role"
                                    value="2"
                                    className="hidden"
                                    checked={selectedRole === "2"}
                                    onChange={() => {
                                      setSelectedRole("2");
                                      setRoleError(false);
                                    }}
                                  />
                                  <div
                                    className={`w-full py-2 text-center rounded-s-lg border-t-2 border-b-2 border-l-2 border-r-2 ${
                                      selectedRole === "2"
                                        ? "bg-[#FF6600] text-white border-[#FF6600]"
                                        : "bg-white text-gray-700 border-gray-300"
                                    }`}
                                  >
                                    Client
                                  </div>
                                </label>
                                <label className="cursor-pointer w-1/2">
                                  <input
                                    type="radio"
                                    name="role"
                                    value="3"
                                    className="hidden"
                                    checked={selectedRole === "3"}
                                    onChange={() => {
                                      setSelectedRole("3");
                                      setRoleError(false);
                                    }}
                                  />
                                  <div
                                    className={`w-full py-2 text-center rounded-e-lg border-t-2 border-b-2 border-l-0 border-r-2 ${
                                      selectedRole === "3"
                                        ? "bg-[#FF6600] text-white border-[#FF6600]"
                                        : "bg-white text-gray-700 border-gray-300"
                                    }`}
                                  >
                                    Prestataire
                                  </div>
                                </label>
                              </div>
                              {roleError && (
                                <div className="text-danger fs-12">
                                  Veuillez sélectionner un rôle
                                </div>
                              )}
                            </div>

                            <TurnstileWidget
                              onTokenChange={setTurnstileToken}
                              onRequirementChange={setTurnstileRequired}
                              resetKey={turnstileResetKey}
                            />
                            {turnstileError && (
                              <div className="mb-2 text-danger fs-12">
                                {turnstileError}
                              </div>
                            )}

                            <div className="text-center mt-4">
                              <button
                                disabled={isSubmitting}
                                type="button"
                                onClick={async () => {
                                  const validationErrors = await validateForm();

                                  const requiredFieldsFilled =
                                    values.firstName &&
                                    values.lastName &&
                                    values.email &&
                                    values.password &&
                                    values.confirmPassword &&
                                    values.gender &&
                                    values.birthDate &&
                                    phone &&
                                    selectedRole;

                                  if (
                                    Object.keys(validationErrors).length ===
                                      0 &&
                                    requiredFieldsFilled &&
                                    (!turnstileRequired || turnstileToken)
                                  ) {
                                    setTurnstileError("");
                                    setStep(true);
                                  } else {
                                    if (turnstileRequired && !turnstileToken) {
                                      setTurnstileError(
                                        "Veuillez valider la protection anti-robot.",
                                      );
                                    }
                                    if (!phone) {
                                      setPhoneError(true);
                                    }
                                    if (!selectedRole) {
                                      setRoleError(true);
                                    }
                                    Object.keys(validationErrors).forEach(
                                      (field) => {
                                        setFieldTouched(field, true);
                                      },
                                    );
                                  }
                                }}
                                className="btn text-white hover:!bg-[#1a71b9] !bg-[#1A64B9] !border-[#1A64B9]  btn-block uppercase"
                              >
                                S'inscrire
                              </button>
                            </div>
                          </>
                        ) : (
                          <TelVerification
                            setStep={setStep}
                            email={values.email}
                            setPhoneNumber={setPhone}
                            phone={phone}
                            setCountry={setCountry}
                            setDialCode={setDialCode}
                            country={country}
                            dialCode={dialCode}
                            turnstileToken={turnstileToken}
                            turnstileRequired={turnstileRequired}
                            onTurnstileConsumed={() => {
                              setTurnstileToken(null);
                              setTurnstileResetKey((current) => current + 1);
                            }}
                          />
                        )}
                      </form>
                    )}
                  </Formik>

                  {!step && (
                    <>
                      <div className="new-account mt-3">
                        <p className="">
                          {" "}
                          Vous avez déja un compte ?{" "}
                          <Link className="text-primary underline" to="/login">
                            Se connecter
                          </Link>
                        </p>
                      </div>
                      <div className="flex w-full justify-center gap-2 mt-4 max-[769px]:flex-col ">
                        {/* <button className="flex gap-2  items-center justify-center bg-white border border-gray-300 text-gray-800 hover:bg-gray-100 px-4 py-2 rounded-lg shadow">
                        <i className="fa fa-google "></i> Connecter avec Google
                      </button> */}

                        <CustomGoogleButton />

                        <button
                          type="button"
                          onClick={handleFacebookLogin}
                          className="flex w-1/3 max-[769px]:w-full gap-2 items-center justify-center bg-white border border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-[10px] "
                        >
                          <FacebookIcon />
                          <div className="flex flex-col justify-start text-[#19295C]">
                            <span className="font-normal text-[7px] text-start">
                              S'inscrire avec
                            </span>
                            <span className="font-semibold text-[14px] text-start">
                              Facebook
                            </span>
                          </div>
                        </button>
                        <button
                          type="button"
                          onClick={handleAppleLogin}
                          className="flex w-1/3 max-[769px]:w-full gap-2 items-center justify-center bg-white border border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-[10px] "
                        >
                          <AppleIcon />
                          <div className="flex flex-col justify-start text-[#19295C]">
                            <span className="font-normal text-[7px] text-start">
                              S'inscrire avec
                            </span>
                            <span className="font-semibold text-[14px] text-start">
                              Apple
                            </span>
                          </div>
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    errorMessage: state.auth.errorMessage,
    successMessage: state.auth.successMessage,
    showLoading: state.auth.showLoading,
  };
};

export default connect(mapStateToProps)(Register);
